import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import useDeletePendingProfile from "../../Libs/useDeletePendingDelete";
import { GoAlertFill } from "react-icons/go";
import { RiDeleteBin5Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css"; 
import { useLocalStorageWithExpiry } from "../../../Utils/useLocalStorageWithExpiry";
import { CiFileOn } from "react-icons/ci";

const PendingDeleteCard = ({ deleteData, isLoading, error }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectedItems, setSelectedItems] = useLocalStorageWithExpiry(
    "selectedItemsToDelete",
    [],
    5 * 60 * 1000 // 5 minutes expiration
  );
  const [isDeleting, setIsDeleting] = useState(false); 

  const deletePendingProfileMutation = useDeletePendingProfile();

  const handleDeleteConfirm = () => {
    const payload = {};

    // Filter and add selected items to the payload
    const otherLicenses = selectedItems.filter(item => item.type === "otherLicenses");
    const otherDocuments = selectedItems.filter(item => item.type === "otherDocuments");

    if (otherLicenses.length) {
      payload.otherLicenses = otherLicenses.map(item => ({
        name: item.name,
        fileUrl: item.fileUrl,
      }));
    }

    if (otherDocuments.length) {
      payload.otherDocuments = otherDocuments.map(item => ({
        name: item.name,
        fileUrl: item.fileUrl,
      }));
    }

    if (Object.keys(payload).length) {
      setIsDeleting(true); 
      deletePendingProfileMutation.mutate(payload, {
        onSuccess: () => {
          setIsDeleting(false); 
          setSelectedItems([]); 
          localStorage.removeItem("selectedItemsToDelete"); 
          setShowOverlay(false); 
          toast.success("Items deleted successfully!"); 
        },
        onError: () => {
          setIsDeleting(false); 
          toast.error("Error deleting items. Please try again."); 
        },
      });
    }
  };

  const handleSelectItem = (item, type) => {
    const isSelected = selectedItems.some(
      selected => selected.fileUrl === item.fileUrl && selected.type === type
    );
    if (isSelected) {
      setSelectedItems(
        selectedItems.filter(
          selected => selected.fileUrl !== item.fileUrl || selected.type !== type
        )
      );
    } else {
      setSelectedItems([...selectedItems, { ...item, type }]);
    }
  };

 
  const renderDocumentLinks = (documents, type) => {
    if (!documents) return null;
    return documents.map((field, index) => (
      <div key={field._id || `${field.name}-${index}`} className="file-download">
        <div className="file">
        <h4>{field.name}</h4>
        <CiFileOn />
        </div>
        <div className="in">
          <a href={field.fileUrl} target="_blank" rel="noopener noreferrer">
            View (PDF)
          </a>
          <input
            type="checkbox"
            checked={selectedItems.some(item => item.fileUrl === field.fileUrl && item.type === type)}
            onChange={() => handleSelectItem(field, type)}
          />
        </div>
      </div>
    ));
  };

  if (error) {
    toast.error("Error fetching data."); // Error notification
    return <div>Error fetching data</div>;
  }

  return (
    <Fragment>
      <ToastContainer/>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          {showOverlay && (
            <div className="delete-per-overlay">
              <div className="card">
                <GoAlertFill className="icon" />
                <h3>Confirm Deletion</h3>
                <p> Are you sure you want to delete the selected item(s)?</p>
                <div className="btn">
                  <button onClick={() => setShowOverlay(false)}>Cancel</button>
                  <button onClick={handleDeleteConfirm} disabled={isDeleting}>
                    {isDeleting ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="pending-update-card">
            <div className="per-profile-update">
                {deleteData?.otherLicenses?.fieldValue && (
                  <div className="section">
                    <h4>Licenses</h4>
                    {renderDocumentLinks(deleteData.otherLicenses.fieldValue, "otherLicenses")}
                  </div>
                )}
                {deleteData?.otherDocuments?.fieldValue && (
                  <div className="section">
                    <h4>Other Documents</h4>
                    {renderDocumentLinks(deleteData.otherDocuments.fieldValue, "otherDocuments")}
                  </div>
                )}
            </div>

            {selectedItems.length > 0 && (
              <button onClick={() => setShowOverlay(true)} className="delete-pending-btn">
                <RiDeleteBin5Line /> Delete Selected
              </button>
            )}
          </div>
        </>
      )}
    </Fragment>
  );
};

PendingDeleteCard.propTypes = {
  deleteData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

export default PendingDeleteCard;

